import { FC } from 'react'

import { ActivityLogItemTemplate } from '../ActivityLogItemTemplate'
import { DeleteNoteModal } from './deleteNote.modal'
import { NoteIcon } from './NoteIcon'

export const ActivityLogNoteItem: FC<{
  isLast: boolean
  summary: string
  email: string | undefined
  createdAt: string
  activityLogId: string
  'data-testid': string
}> = ({
  isLast,
  summary,
  email,
  createdAt,
  activityLogId,
  'data-testid': dataTestId
}) => {
  return (
    <ActivityLogItemTemplate
      icon={<NoteIcon />}
      isLast={isLast}
      data-testid={dataTestId}
    >
      <ActivityLogItemTemplate.Body>
        <ActivityLogItemTemplate.Title
          button={<DeleteNoteModal activityLogId={activityLogId} />}
        >
          {summary}
        </ActivityLogItemTemplate.Title>
        <ActivityLogItemTemplate.Metadata email={email} createdAt={createdAt} />
      </ActivityLogItemTemplate.Body>
    </ActivityLogItemTemplate>
  )
}
